import {useSchemaListThesaurusIds} from 'schema/hooks/useSchemaListThesaurusIds';
import {useAgentSchemas} from 'schemas/hooks/useAgentSchemas';

export const useAgentsThesaurusIds = () => {
  const agentSchemas = useAgentSchemas();

  return useSchemaListThesaurusIds(agentSchemas);
};
